<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                </span>
                PRODOTTI MAPPATI
            </div>
        </div>    
        <div class="tab-cont" id="style-3">
                
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th class="text">BarCode</th>
                        <th class="text">Descrizione</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr v-for="prodotto in prodotti" :key="prodotto.code">
                            <td class="text pointer" >{{prodotto.code}}</td>
                            <td class="text" >{{prodotto.descrizio}}</td>
                        </tr>
                    </tbody>
            </table>
        </div>
        
    </div>
</template>






<script>
// @ is an alias to /src
import { store } from '../store/store.js'

export default {
  name: 'TabellaMapP',
  data: function () {
            return {
                prodotti:[],
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    displayProduct() {
        this.axios.post(this.store.path+'displayProduct',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`
    }}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
        })
    },
  },
  beforeMount() {
      this.displayProduct();
  },
  
}
</script>



<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 10px;
    height: 100vh;
}
.con-sal {
    display: flex;
    flex-direction: column;
}
.nav-sale{
    flex-basis: 15vh;
}

.tab-cont {
    margin: auto;
    margin-top: 20px;
    background: #F5F5F5;
    overflow-y: scroll;
    flex-basis: 80%;
    width: 100vw;
}
.table,tr {
    width: 100vw;
}
thead {
    position: fixed;
    top:13vh;
    z-index: 10000;
}

#style-3::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb
{
  background-color: #000000;
}

th,td {
    width: 50vw;
}
</style>